<section
  *ngIf="presentation === 'compact'; else defaultScenario"
  class="py-0"
  aria-labelledby="fundraiser-scenario-heading"
>
  <div class="card border-0 bg-light">
    <div class="card-body p-3 p-md-4">
      <h2 id="fundraiser-scenario-heading" class="h4 fw-bold mb-3">
        Build your fundraiser scenario
      </h2>

      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold" for="fundraiserAmount">
            Online fundraising amount
          </label>
          <div class="input-group">
            <span class="input-group-text" aria-hidden="true">$</span>
            <input
              id="fundraiserAmount"
              class="form-control fw-semibold"
              type="text"
              min="0"
              max="10000000"
              step="100"
              inputmode="decimal"
              [value]="compactAmountInputValue"
              aria-describedby="fundraiserProfileNote"
              (focus)="beginCompactAmountEditing()"
              (input)="onAmountInput($event)"
              (blur)="endCompactAmountEditing()"
            />
          </div>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold" for="fundraiserDonations">
            Number of online donations
          </label>
          <input
            id="fundraiserDonations"
            class="form-control"
            type="number"
            min="1"
            max="100000"
            step="1"
            [disabled]="isZeroScenario"
            [value]="donationCount"
            (change)="onDonationCountChange($event)"
          />
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold mb-1" for="fundraiserAverage">
            Average donation
          </label>
          <div
            id="fundraiserAverageHelp"
            class="form-text text-body-secondary mt-0 mb-1"
          >
            Calculated automatically
          </div>
          <div class="input-group">
            <span class="input-group-text" aria-hidden="true">$</span>
            <input
              id="fundraiserAverage"
              class="form-control fw-semibold bg-body-tertiary"
              type="text"
              readonly
              [value]="averageDonationCents / 100"
              aria-describedby="fundraiserAverageHelp"
              aria-live="polite"
            />
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap align-items-center gap-2 mt-3">
        <p id="fundraiserProfileNote" class="small text-body-secondary mb-0">
          Based on an anonymized real school fundraiser pattern.
        </p>
        <button
          *ngIf="donationCountOverride !== null"
          type="button"
          class="btn btn-link btn-sm p-0"
          (click)="useProfileEstimate()"
        >
          Use profile estimate
        </button>
      </div>
    </div>
  </div>
</section>

<ng-template #defaultScenario>
  <section aria-labelledby="fundraiser-amount-heading">
    <div class="row justify-content-center text-center">
      <div class="col-12 col-lg-9">
        <h2 id="fundraiser-amount-heading" class="h3 fw-bold mb-3">
          How much do you expect to collect online?
        </h2>

        <div class="fundraising-comparison__amount mx-auto mb-2">
          <label class="visually-hidden" for="fundraiserAmount">
            Expected online donation amount in dollars
          </label>
          <div class="input-group input-group-lg">
            <span class="input-group-text" aria-hidden="true">$</span>
            <input
              id="fundraiserAmount"
              class="form-control form-control-lg fw-semibold"
              type="number"
              min="0"
              max="10000000"
              step="100"
              inputmode="decimal"
              [value]="amountDollars"
              aria-describedby="fundraiserAssumptionSummary"
              (input)="onAmountInput($event)"
            />
          </div>
        </div>

        <p
          id="fundraiserAssumptionSummary"
          class="small text-body-secondary mb-1"
        >
          <ng-container
            *ngIf="
              scenario.donationCountSource === 'override';
              else profileEstimate
            "
          >
            Using your assumption of {{ donationCount | number }} online
            donations averaging {{ formatMoney(averageDonationCents) }}.
          </ng-container>
          <ng-template #profileEstimate>
            Based on approximately {{ donationCount | number }} online donations
            from an anonymized real school fundraiser pattern.
          </ng-template>
        </p>

        <details class="fundraising-comparison__assumptions text-start mx-auto">
          <summary class="btn btn-link btn-sm px-0 fw-semibold">
            Adjust assumptions
          </summary>
          <div class="border rounded-3 bg-light p-3 mt-2">
            <div class="row g-3 align-items-end">
              <div class="col-12 col-sm-7">
                <label class="form-label fw-semibold" for="fundraiserDonations">
                  Number of online donations
                </label>
                <input
                  id="fundraiserDonations"
                  class="form-control"
                  type="number"
                  min="1"
                  max="100000"
                  step="1"
                  [value]="donationCount"
                  (change)="onDonationCountChange($event)"
                />
              </div>
              <div class="col-12 col-sm-5">
                <p class="small text-body-secondary mb-1">Average donation</p>
                <p class="fw-semibold mb-2">
                  {{ formatMoney(averageDonationCents) }}
                </p>
              </div>
            </div>
            <button
              *ngIf="donationCountOverride !== null"
              type="button"
              class="btn btn-link btn-sm px-0 mt-2"
              (click)="useProfileEstimate()"
            >
              Use profile estimate
            </button>
            <p class="small text-body-secondary mb-0 mt-2">
              The estimate comes from one anonymized school fundraiser's card
              donation pattern. It is not a universal average.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
</ng-template>
